<div class="row">
  <div class="map-selector">
    <form [formGroup]="form">
      <div class="row">
        <app-input
          class="col-6"
          type="number"
          label="latitude"
          [formControl]="form_latitude"
        ></app-input>
        <app-input
          class="col-6"
          type="number"
          label="longitude"
          [formControl]="form_longitude"
        ></app-input>
      </div>
      <div>
        <span>Parcelles Cadastrales : </span>
        <mat-chip-listbox #chipGrid>
          <mat-chip-option
            *ngFor="let name of landRegistriesName; let index = index"
            (removed)="removeLandRegistry(index)"
            [class]="index === 0 ? 'first-chip' : ''"
          >
            {{ name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
          <mat-error *ngIf="form_landRegistries.hasError('required')"
            >Sélectionnez les parcelles et ajuster la localisation sur le
            plan</mat-error
          >
        </mat-chip-listbox>
      </div>
    </form>
  </div>
  <div class="map-container">
    <app-new-map
      [initZoom]="19"
      [hasLayerControls]="false"
      [isLocateEnabled]="false"
      [hasSatelliteView]="true"
      [hasPlanView]="false"
      [hasCadastreView]="true"
      [hasEventParcelles]="true"
      [updateLocationEnabled]="true"
      [defaultLayer]="'SATELLITE'"
      [showPropPopup]="false"
      [props]="[prop]"
      [parcelleInputUnSelected]="parcelleUnselected$"
      (locationUpdated)="mapLocationUpdated($event)"
      (parcelleSelected)="mapParcelleSelected($event)"
      (parcelleUnSelected)="mapParcelleUnSelected($event)"
    >
    </app-new-map>
  </div>
</div>
